import React from 'react';
import type { Melody } from '../lib/types';
import MelodyNotes from './MelodyNotes';

interface MelodyPlayerProps {
  melody: Melody;
  iteration: number;
  remainingCount: number;
  isPlaying: boolean;
  timeToEnd: string;
  onPlaybackComplete?: () => void;
  isLoading?: boolean;
  melodyIndex: number;
}

const MelodyPlayer: React.FC<MelodyPlayerProps> = ({ 
  melody, 
  iteration, 
  remainingCount,
  isPlaying,
  timeToEnd,
  onPlaybackComplete,
  isLoading = false,
  melodyIndex
}) => {
  const formatNumber = (num: number): string => {
    return new Intl.NumberFormat('en-US').format(num);
  };

  return (
    <article className="rounded-lg shadow-md">
      <header className="text-center mb-4">
        <h2 className="text-xl font-semibold mb-2">Current Melody</h2>
        <div className="grid grid-cols-2 gap-x-4 mx-auto">
          <p className="text-sm text-gray-300 text-right">Iteration:</p>
          <p className="text-sm text-gray-300 text-left">
            {isLoading ? (
              <span className="inline-block h-4 w-16 bg-gray-700 rounded animate-pulse"></span>
            ) : (
              formatNumber(iteration)
            )}
          </p>
          
          <p className="text-sm text-gray-300 text-right">Total Melodies:</p>
          <p className="text-sm text-gray-300 text-left">
            {isLoading ? (
              <span className="inline-block h-4 w-24 bg-gray-700 rounded animate-pulse"></span>
            ) : (
              formatNumber(remainingCount)
            )}
          </p>
          
          <p className="text-sm text-gray-300 text-right">Time to end:</p>
          <p className="text-sm text-gray-300 text-left">
            {isLoading ? (
              <span className="inline-block h-4 w-24 bg-gray-700 rounded animate-pulse"></span>
            ) : (
              timeToEnd
            )}
          </p>
        </div>
      </header>
      
      <MelodyNotes 
        melody={melody}
        shouldPlay={isPlaying}
        onComplete={onPlaybackComplete}
        isLoading={isLoading}
        melodyIndex={melodyIndex}
      />
    </article>
  );
};

export default MelodyPlayer; 